module.exports = __webpack_public_path__ + "static/english-d9719d5accf0acbbd48bdc866a143a59.svg";